import { render, staticRenderFns } from "./discountReport.vue?vue&type=template&id=15b5f528&"
import script from "./discountReport.vue?vue&type=script&lang=js&"
export * from "./discountReport.vue?vue&type=script&lang=js&"
import style0 from "./discountReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports